export default "__VITE_ASSET__0294123e__"